import axios from "axios";
import API from "@/models/API";

axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem(
    "accessToken"
)}`;

export default {
    namespaced: true,

    state: () => ({
        systemNotifications: [],
        rewardPoints: null,
        rewardCurrency: null,
        rewardRounding: null

    }),

    mutations: {
        setSystemNotifications(state, payload) {
            state.systemNotifications = payload;
        },

        setRewardPoints(state, payload) {
            state.rewardPoints = Number(payload);
        },

        setRewardCurrency(state, payload) {
            state.rewardCurrency = Number(payload);
        },

        setRewardRounding(state, payload) {
            state.rewardRounding = payload;
        },
    },

    actions: {
        async getSystemNotifications({ commit }) {
            try {
                const { data } = await API.get(
                    `/common/system-notifications`
                );

                commit("setSystemNotifications", data.data);
            } catch (ex) {
                console.error(ex.response.data);
            }
        },

        async updateActivator({ commit }, item) {
            try {
                item.loading = true;

                if (item.system_notification_id) {
                    await API.put(
                        `/stores/${localStorage.getItem(
                            "storeId"
                        )}/flags/reward`
                    ,
                        {
                            [item.updateProp]: item.active,
                            system_notification_id: item.system_notification_id
                        }
                    );
                } else {
                    await API.put(
                        `/stores/${localStorage.getItem(
                            "storeId"
                        )}/flags/reward`
                    ,
                        { [item.updateProp]: item.active }
                    );
                }

                commit(item.commit, item.active, {
                    root: true
                });
                item.loading = false;
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: `You have successfully updated ${item.successText}!`
                    },
                    { root: true }
                );
            } catch (ex) {
                item.active = !item.active;
                item.loading = false;
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },
                    { root: true }
                );
            }
        },

        async updateReward({ commit }, { item, url, commitText, successText }) {
            try {
                commit("setLoading", true, { root: true });

                await API.put(
                    `/stores/${localStorage.getItem("storeId")}/${url}`,
                    item
                );

                commit(commitText, item, { root: true });

                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: `You have successfully updated ${successText}!`
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async getRewardPoints({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await API.get(
                    `/stores/${localStorage.getItem("storeId")}`
                );

                commit("setRewardPoints", data.data.reward_points || data.data.company.reward_points)
                commit("setRewardCurrency", data.data.reward_amount || data.data.company.reward_amount)
                commit("setRewardRounding", data.data.reward_floor || data.data.company.reward_floor)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async updateRewardPoints({ commit, state }) {
            try {
                commit("setLoading", true, { root: true });

                await API.put(
                    `/stores/${localStorage.getItem("storeId")}/flags/reward-points`,
                    {
                        reward_points: state.rewardPoints,
                        reward_amount: state.rewardCurrency,
                        reward_floor: state.rewardRounding,
                    }
                );

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        }
    }
};
